(() => {
"use strict";
var $62faee361d1a8172$var$data;
var $62faee361d1a8172$var$x_scale;
var $62faee361d1a8172$var$bar_y;
var $62faee361d1a8172$var$bar_height;
var $62faee361d1a8172$var$y_label_width;
var $62faee361d1a8172$var$x_axis;
var $62faee361d1a8172$var$width;
var $62faee361d1a8172$var$now;
function $62faee361d1a8172$var$expiration_date(d) {
    return new Date(d.published.getTime() + 15984000000);
}
function $62faee361d1a8172$var$max(arr) {
    return Math.max.apply(null, Object.keys(arr).map(function(e) {
        return arr[e];
    }));
}
function $62faee361d1a8172$var$offset(d) {
    if ($62faee361d1a8172$var$bar_y[d.name] === undefined) {
        var m = Object.keys($62faee361d1a8172$var$bar_y).length === 0 ? -$62faee361d1a8172$var$bar_height : $62faee361d1a8172$var$max($62faee361d1a8172$var$bar_y);
        $62faee361d1a8172$var$bar_y[d.name] = m + $62faee361d1a8172$var$bar_height;
    }
    return "translate(" + $62faee361d1a8172$var$x_scale(d.published) + ", " + $62faee361d1a8172$var$bar_y[d.name] + ")";
}
function $62faee361d1a8172$var$bar_width(d, i) {
    // check for next rev of this name, or published RFC
    for(i++; i < $62faee361d1a8172$var$data.length; i++){
        if ($62faee361d1a8172$var$data[i].name === d.name || $62faee361d1a8172$var$data[i].name.match(/^rfc/)) break;
    }
    var w;
    if (d.name.match(/^draft-/)) {
        // don't extend the bar past the expiration date of the document
        w = i === $62faee361d1a8172$var$data.length ? $62faee361d1a8172$var$expiration_date(d) : $62faee361d1a8172$var$data[i].published;
        w = w > $62faee361d1a8172$var$expiration_date(d) ? $62faee361d1a8172$var$expiration_date(d) : w;
    } else // documents other than drafts don't expire after 185 days
    w = i === $62faee361d1a8172$var$data.length ? new Date() : $62faee361d1a8172$var$data[i].published;
    return $62faee361d1a8172$var$x_scale(w) - $62faee361d1a8172$var$x_scale(d.published);
}
function $62faee361d1a8172$var$scale_x() {
    // scale data to width of container minus y label width
    $62faee361d1a8172$var$x_scale = d3.scaleTime().domain([
        d3.min($62faee361d1a8172$var$data, function(d) {
            return d.published;
        }),
        d3.max($62faee361d1a8172$var$data, function(d) {
            return d.published;
        })
    ]).range([
        $62faee361d1a8172$var$y_label_width,
        $62faee361d1a8172$var$width
    ]);
    // if the end of the timeline is past the current date, show it
    var tv = $62faee361d1a8172$var$data.slice(0, -1);
    $62faee361d1a8172$var$now = Date.now();
    if (tv[tv.length - 1].published > $62faee361d1a8172$var$now) tv.push(new Date($62faee361d1a8172$var$now));
    // x label format
    var format = d3.timeFormat("%b %Y");
    // resort data by publication time to suppress some ticks if they are closer
    // than 12px and have a different label from the one before; and don't add a
    // tick for the final pseudo entry
    tv = tv.sort(function(a, b) {
        return a.published - b.published;
    }).map(function(d, i, arr) {
        if (i === 0 || $62faee361d1a8172$var$x_scale(d.published) > $62faee361d1a8172$var$x_scale(arr[i - 1].published) + 12 && format(d.published) !== format(arr[i - 1].published)) return d.published;
    }).filter(function(d) {
        return d !== undefined;
    });
    $62faee361d1a8172$var$x_axis = d3.axisBottom($62faee361d1a8172$var$x_scale).tickValues(tv).tickFormat(function(d) {
        if (d.getTime() < $62faee361d1a8172$var$now) return format(d);
        return "Now";
    });
}
function $62faee361d1a8172$var$update_x_axis() {
    d3.select("#doc-timeline svg .x.axis").call($62faee361d1a8172$var$x_axis).selectAll("text").style("text-anchor", "end").attr("transform", "translate(-14, 2) rotate(-60)");
}
function $62faee361d1a8172$var$update_timeline() {
    $62faee361d1a8172$var$bar_y = {};
    $62faee361d1a8172$var$scale_x();
    var chart = d3.select("#doc-timeline svg").attr("width", $62faee361d1a8172$var$width);
    // enter data (skip the last pseudo entry)
    var bar = chart.selectAll("g").data($62faee361d1a8172$var$data.slice(0, -1));
    bar.attr("transform", $62faee361d1a8172$var$offset).select("rect").attr("width", $62faee361d1a8172$var$bar_width);
    $62faee361d1a8172$var$update_x_axis();
}
function $62faee361d1a8172$var$draw_timeline() {
    $62faee361d1a8172$var$bar_height = parseFloat($("body").css("line-height"));
    var div = $("#doc-timeline");
    div.addClass("my-3");
    if (div.is(":empty")) div.append("<svg></svg>");
    var chart = d3.select("#doc-timeline svg").attr("width", $62faee361d1a8172$var$width);
    var defs = chart.append("defs");
    var fade = defs.append("linearGradient").attr("id", "maskGradient");
    fade.append("stop").attr("offset", 0.9).attr("stop-color", "white").attr("stop-opacity", 1);
    fade.append("stop").attr("offset", 1).attr("stop-color", "white").attr("stop-opacity", 0);
    var mask = defs.append("mask").attr("id", "fade").attr("maskContentUnits", "objectBoundingBox");
    mask.append("rect").attr("height", 1).attr("width", 1).attr("fill", "url(#maskGradient)");
    var y_labels = $62faee361d1a8172$var$data.map(function(d) {
        return d.name;
    }).filter(function(val, i, self) {
        return self.indexOf(val) === i;
    });
    // calculate the width of the widest y axis label by drawing them off-screen
    // and measuring the bounding boxes
    $62faee361d1a8172$var$y_label_width = 10 + d3.max(y_labels, function(l) {
        var lw;
        var text = chart.append("text");
        text.attr("class", "y axis").attr("transform", "translate(0, " + -$62faee361d1a8172$var$bar_height + ")");
        text.text(l).each(function() {
            lw = this.getBBox().width;
        }).remove().remove();
        return lw;
    });
    // update
    $62faee361d1a8172$var$update_timeline();
    // re-order data by document name, for CSS background color alternation
    var ndata = [];
    y_labels.forEach(function(l) {
        ndata = ndata.concat($62faee361d1a8172$var$data.filter(function(d) {
            return d.name === l;
        }));
    });
    $62faee361d1a8172$var$data = ndata;
    // enter data (skip the last pseudo entry)
    var bar = chart.selectAll("g").data($62faee361d1a8172$var$data.slice(0, -1));
    var g = bar.enter().append("g");
    g.attr("class", "bar").attr("transform", $62faee361d1a8172$var$offset);
    var a = g.append("a");
    a.attr("xlink:href", function(d) {
        return d.url;
    });
    var rect = a.append("rect").attr("height", $62faee361d1a8172$var$bar_height).attr("width", $62faee361d1a8172$var$bar_width).attr("class", "btn").attr("type", "button").attr("mask", function(d, i) {
        // apply gradient if the document is a draft and expired
        if (d.name.match(/^draft-/) && $62faee361d1a8172$var$bar_width(d, i) >= $62faee361d1a8172$var$x_scale($62faee361d1a8172$var$expiration_date(d)) - $62faee361d1a8172$var$x_scale(d.published)) return "url(#fade)";
    });
    var text = g.append("text");
    text.attr("x", 3).attr("y", $62faee361d1a8172$var$bar_height / 2);
    text.text(function(d) {
        return d.rev;
    });
    var y_scale = d3.scalePoint().domain(y_labels).range([
        0,
        $62faee361d1a8172$var$max($62faee361d1a8172$var$bar_y) + $62faee361d1a8172$var$bar_height
    ]);
    var y_axis = d3.axisLeft(y_scale).tickValues(y_labels);
    chart.append("g").attr("class", "x axis").attr("transform", "translate(0, " + ($62faee361d1a8172$var$max($62faee361d1a8172$var$bar_y) + $62faee361d1a8172$var$bar_height) + ")");
    $62faee361d1a8172$var$update_x_axis();
    var g = chart.append("g");
    g.attr("class", "y axis").attr("transform", "translate(10, " + $62faee361d1a8172$var$bar_height / 2 + ")");
    g.call(y_axis).selectAll("text").style("text-anchor", "start");
    // set height of timeline
    var x_label_height;
    d3.select(".x.axis").each(function() {
        x_label_height = this.getBBox().height;
    });
    chart.attr("height", $62faee361d1a8172$var$max($62faee361d1a8172$var$bar_y) + $62faee361d1a8172$var$bar_height + x_label_height);
}
d3.json("doc.json").then(function(json) {
    $62faee361d1a8172$var$data = json.rev_history;
    if ($62faee361d1a8172$var$data.length) {
        // make js dates out of publication dates
        $62faee361d1a8172$var$data.forEach(function(d) {
            d.published = new Date(d.published);
        });
        // add pseudo entry when the ID will expire
        $62faee361d1a8172$var$data.push({
            name: "",
            rev: "",
            published: $62faee361d1a8172$var$expiration_date($62faee361d1a8172$var$data[$62faee361d1a8172$var$data.length - 1])
        });
        $62faee361d1a8172$var$width = $("#doc-timeline").width();
        $62faee361d1a8172$var$draw_timeline();
    }
});
$(window).on({
    resize: function() {
        var g = $("#doc-timeline svg");
        g.remove();
        $62faee361d1a8172$var$width = $("#doc-timeline").width();
        $("#doc-timeline").append(g);
        $62faee361d1a8172$var$update_timeline();
    }
});

})();
//# sourceMappingURL=document_timeline.js.map
